// src/pages/History/RenaissanceReformation/ItalianRenaissance.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Renaissance_&_Reformation_-_Italian_Renaissance.png';

export default function HistoryPageItalianRenaissance() {
  return (
    <TopicPage
      topicKey="Italian Renaissance"
      title="History: Italian Renaissance"
      backgroundImage={bg}
      startRoute="/History-Italian-Renaissance-Go"
      scrollLabels={[
        "Art and Architecture",
        "Humanism and Scholars",
        "Florence and the Medici"
      ]}
      backRoute="/history-renaissance"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
